export default __webpack_public_path__ + "9517b35c88feafa68f7d8c7ef44483e0.svg";